import React from 'react';
import { RadioButton } from './RadioButton';
import styles from '../../styles/components/answers/RadioButtonsList.module.css';
import UUID from '@ax2/common/model/UUID';
import {
  ParticipantDefinedFieldData,
  ParticipantDefinedField,
} from './ParticipantDefinedOption';

export interface RadioButtonsListOption {
  id: UUID;
  title: string;
  subtitle?: string;
}
export type RadioButtonsListParticipantDefinedOption = ParticipantDefinedFieldData;

export interface RadioButtonsListData {
  options: (
    | RadioButtonsListOption
    | RadioButtonsListParticipantDefinedOption)[];
  preselected?: UUID;
  onCompletion: (opt: UUID) => void;
  key?: string;
}

function getTitleElement(
  opt: RadioButtonsListOption | RadioButtonsListParticipantDefinedOption
) {
  return 'title' in opt ? (
    <span className={styles.selectionText}>{opt.title}</span>
  ) : (
    <div className={styles.selectionInput} onClick={e => e.stopPropagation()}>
      <ParticipantDefinedField {...opt} />
    </div>
  );
}

export const RadioButtonsList: React.FC<RadioButtonsListData> = data => {
  const [selection, setSelection] = React.useState<UUID | undefined>(
    data.preselected
  );
  return (
    <div className={styles.buttonsListWrapper}>
      {data.options.map((option, index) => (
        <div
          key={option.id}
          className={styles.selectionContainer}
          onClick={() => {
            setSelection(option.id);
            data.onCompletion(data.options[index].id);
          }}
        >
          <div>
            <RadioButton
              tabIndex={index + 1}
              hasSelection={selection !== undefined && selection === option.id}
            />
          </div>
          {getTitleElement(option)}
        </div>
      ))}
    </div>
  );
};
